<!-- 弹窗 -->
<template>
<div v-if="isShow" class='modal'>
  <div class="container">
    <div :class="[{'loadTitle': !tag}, 'title']">{{title}}</div>
    <div :class="[{'loadContent': !tag}, 'content']">{{content}}</div>
    <div class="button" @click='handleLogin'>{{button}}</div>
  </div>
  <img
    class="close"
    @click='close'
    src="../../../assets/icons/diversion_close.png"
    alt=""
  >
</div>
</template>

<script>

import login from '@edu-fe/login'
import Deload from '../../../mixins/downloadApp'
import os from '@edu-fe/os'
export default {
  components: {},
  data() {
    return {

    };
  },
  computed: {
    isIos () {
      return window.navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
    }
  },
  mixins: [
    Deload
  ],
  props: {
    isShow: Boolean,
    tag: Boolean,
    title: String,
    content: String,
    button: String,
  },
  methods: {
    handleLogin() {
      if(this.tag){
        login.login()
        this.$emit('close')
        return ''
      }
      // android 直接下载
      if(os.system === 'android') {
        return window.location.href = 'http://staticedu.wps.cn/app/wpsedu_v1.4_vc_13_gg7.apk'
      }
      // 苹果去sppstore
      if (this.isIos) {
        return window.location.href = 'https://itunes.apple.com/app/apple-store/id1439039386?pt=38515&ct=wpsdownload&mt=8'
      }

    },
    close() {
      this.$emit('close')
    }
  },
  created() {

  },
  mounted() {

  },
}
</script>
<style lang='scss' scoped>
  @charset "UTF-8";

  @import "../../../style/main";
.modal {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background:rgba(0,0,0,.4);
  display: flex;
  flex-direction: column;
  align-items: center;
  border-radius:rem(4);
  z-index: 999999;
  .container {
    width:rem(583);
    height:rem(375);
    background:rgba(255,255,255,1);
    box-shadow:rem(0) rem(17) rem(35) rem(0) rgba(0,0,0,0.4);
    display: flex;
    align-items: center;
    flex-direction: column;
    color:#000;
    font-weight:500;
    margin-top: rem(430);
    .title{
      font-size:rem(42);
      line-height:rem(63);
      margin-top: rem(46);
    }
    .content {
      width:rem(483);
      height:rem(100);
      font-size:rem(32);
      font-weight:400;
      line-height:rem(50);
      text-align: center;
      color:rgba(0,0,0,.4);
      margin: rem(24) 0 rem(32) 0;
    }
    .loadTitle {
      font-size:rem(36);
    }
    .loadContent {
      font-size:rem(28);
    }
    .button {
      width:rem(361);
      height:rem(79);
      background:rgba(251,91,36,1);
      border-radius:rem(40);
      font-size:rem(34);
      color:#fff;
      line-height:rem(79);
      text-align: center;
    }
  }
  .close {
      width: rem(72);
      height: rem(72);
      margin-top: rem(40);
    }
}
</style>
